// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_90e41ca6 rdg_09d341fe","payments":"rdg_85f8ca1a"};